import { render } from "./AvatarManagerModal.vue?vue&type=template&id=204eeb04"
import script from "./AvatarManagerModal.vue?vue&type=script&lang=js"
export * from "./AvatarManagerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__